
export function scrollingBanner() {
    for (let element of document.querySelectorAll(".banner--centered")){
        let textElement = element.querySelector('.mbBanner__content');
        let textHeadline = element.querySelector('.wp-block-heading');

        if(textElement && textHeadline){
            let textHeadlineElementRect = textHeadline.getBoundingClientRect();

            window.addEventListener('scroll', function(e) {
                let positionBanner = element.getBoundingClientRect();
                let diff = window.innerHeight - (positionBanner.y - window.innerHeight / 3);
                let percent = diff/(positionBanner.height/100);
                let multiplicator = textHeadlineElementRect.width/positionBanner.width;

                textElement.style.left = (100 - percent) * multiplicator * 0.5 + "%";
            })
        }
    }
}